export default __webpack_public_path__ + "static/n4-1a73c822c616aa1f6fc985b22ac7fa96.jpg";